export const updateUserInvite = `mutation UpdateUserInvite($input: UpdateUserInviteInput!) {
  updateUserInvite(input: $input) {
    id
    companyId
    userId
    emailAddress
    firstName
    lastName
    title
    dateCreated
  }
}
`;
